export const ORDER_REFERENCE = 'orn';
export const POSTCODE = 'postcode';
export const ANALYTICS_ERROR_MSG = '404 (Not found)';

export const AUTH_STATUS_LOGGED_IN = 'Logged in';
export const AUTH_STATUS_NOT_LOGGED_IN = 'Not logged in';

export const SINGLE_ORDER_FORMAT_REG_EXP = /^BT[a-zA-Z0-9]{6,28}$/i;
export const GROUP_ORDER_FORMAT_REG_EXP = /^GBT[a-zA-Z0-9]{5,27}$/i;
export const POSTCODE_FORMAT_REG_EXP = /^[a-zA-Z]{1,2}[0-9]{1,2}[a-zA-Z]? ?[0-9][a-zA-Z]{2}$/i;

export const ORDER_STATUS_COMPLETED = 'Completed';
